import './App.css';
import NavBar from "./components/NavBar";
import LandingPage from "./pages/LandingPage";


 export default function App() {
  return (
      <section>
          <NavBar />
          <LandingPage />
      </section>

  );
}
